// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    AddProjectPartnerRequest,
    AddProjectPartnerRequestFromJSON,
    AddProjectPartnerRequestToJSON,
    PostPageResponse,
    PostPageResponseFromJSON,
    PostPageResponseToJSON,
    PostRequest,
    PostRequestFromJSON,
    PostRequestToJSON,
    PostResponse,
    PostResponseFromJSON,
    PostResponseToJSON,
    ProjectPageResponse,
    ProjectPageResponseFromJSON,
    ProjectPageResponseToJSON,
    ProjectRequest,
    ProjectRequestFromJSON,
    ProjectRequestToJSON,
    ProjectResponse,
    ProjectResponseFromJSON,
    ProjectResponseToJSON,
  } from '../models';

      export interface AddPartnerRequest {
        projectId: number;
        addProjectPartnerRequest: AddProjectPartnerRequest;
      }

      export interface CreateProjectRequest {
        projectRequest: ProjectRequest;
      }

      export interface CreateProjectPostRequest {
        projectId: number;
        postRequest?: PostRequest;
      }

      export interface DeletePartnerRequest {
        organisationId: number;
        projectId: number;
      }

      export interface DeleteProjectRequest {
        projectId: number;
      }

      export interface GetProjectRequest {
        projectId: number;
      }

      export interface GetProjectPostsRequest {
        projectId: number;
        pageSize?: number;
        page?: number;
      }

      export interface GetProjectsRequest {
        page?: number;
        pageSize?: number;
        query?: string;
        categories?: Array<number>;
      }

      export interface UpdateProjectRequest {
        projectId: number;
        projectRequest: ProjectRequest;
      }


/**
* no description
*/
export interface ProjectsApi {
    /**
      * Add project partner
    */
    addPartner(requestParameters: AddPartnerRequest): Promise<void>
    /**
      * Create a new project
    */
    createProject(requestParameters: CreateProjectRequest): Promise<ProjectResponse>
    /**
      * Create a new post
    */
    createProjectPost(requestParameters: CreateProjectPostRequest): Promise<PostResponse>
    /**
      * Remove the partner from the project
    */
    deletePartner(requestParameters: DeletePartnerRequest): Promise<void>
    /**
      * Delete the project associated with the given projectId
    */
    deleteProject(requestParameters: DeleteProjectRequest): Promise<void>
    /**
      * Get the project associated with the given projectId
    */
    getProject(requestParameters: GetProjectRequest): Promise<ProjectResponse>
    /**
      * Get a list of posts for the given project.
    */
    getProjectPosts(requestParameters: GetProjectPostsRequest): Promise<PostPageResponse>
    /**
      * Paged list of projects
    */
    getProjects(requestParameters: GetProjectsRequest): Promise<ProjectPageResponse>
    /**
      * Update the project associated with the given projectId
    */
    updateProject(requestParameters: UpdateProjectRequest): Promise<ProjectResponse>
}

  /**
  * no description
  */
  export class ProjectsApiImpl extends runtime.BaseAPI implements ProjectsApi {

    /**
      * Add project partner
    */
    async addPartnerRaw(requestParameters: AddPartnerRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling addPartner.');
          }

          if (requestParameters.addProjectPartnerRequest === null || requestParameters.addProjectPartnerRequest === undefined) {
          throw new runtime.RequiredError('addProjectPartnerRequest','Required parameter requestParameters.addProjectPartnerRequest was null or undefined when calling addPartner.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/projects/{projectId}/partners`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: AddProjectPartnerRequestToJSON(requestParameters.addProjectPartnerRequest),
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Add project partner
      */
      async addPartner(requestParameters: AddPartnerRequest): Promise<void> {
        await this.addPartnerRaw(requestParameters);
      }

    /**
      * Create a new project
    */
    async createProjectRaw(requestParameters: CreateProjectRequest): Promise<runtime.ApiResponse<ProjectResponse>> {
          if (requestParameters.projectRequest === null || requestParameters.projectRequest === undefined) {
          throw new runtime.RequiredError('projectRequest','Required parameter requestParameters.projectRequest was null or undefined when calling createProject.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/projects`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: ProjectRequestToJSON(requestParameters.projectRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
      }

      /**
        * Create a new project
      */
      async createProject(requestParameters: CreateProjectRequest): Promise<ProjectResponse> {
        const response = await this.createProjectRaw(requestParameters);
        return await response.value();
      }

    /**
      * Create a new post
    */
    async createProjectPostRaw(requestParameters: CreateProjectPostRequest): Promise<runtime.ApiResponse<PostResponse>> {
          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling createProjectPost.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/projects/{projectId}/posts`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: PostRequestToJSON(requestParameters.postRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostResponseFromJSON(jsonValue));
      }

      /**
        * Create a new post
      */
      async createProjectPost(requestParameters: CreateProjectPostRequest): Promise<PostResponse> {
        const response = await this.createProjectPostRaw(requestParameters);
        return await response.value();
      }

    /**
      * Remove the partner from the project
    */
    async deletePartnerRaw(requestParameters: DeletePartnerRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling deletePartner.');
          }

          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling deletePartner.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/projects/{projectId}/partners/{organisationId}`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))).replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Remove the partner from the project
      */
      async deletePartner(requestParameters: DeletePartnerRequest): Promise<void> {
        await this.deletePartnerRaw(requestParameters);
      }

    /**
      * Delete the project associated with the given projectId
    */
    async deleteProjectRaw(requestParameters: DeleteProjectRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling deleteProject.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Delete the project associated with the given projectId
      */
      async deleteProject(requestParameters: DeleteProjectRequest): Promise<void> {
        await this.deleteProjectRaw(requestParameters);
      }

    /**
      * Get the project associated with the given projectId
    */
    async getProjectRaw(requestParameters: GetProjectRequest): Promise<runtime.ApiResponse<ProjectResponse>> {
          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling getProject.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
      }

      /**
        * Get the project associated with the given projectId
      */
      async getProject(requestParameters: GetProjectRequest): Promise<ProjectResponse> {
        const response = await this.getProjectRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a list of posts for the given project.
    */
    async getProjectPostsRaw(requestParameters: GetProjectPostsRequest): Promise<runtime.ApiResponse<PostPageResponse>> {
          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling getProjectPosts.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/projects/{projectId}/posts`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostPageResponseFromJSON(jsonValue));
      }

      /**
        * Get a list of posts for the given project.
      */
      async getProjectPosts(requestParameters: GetProjectPostsRequest): Promise<PostPageResponse> {
        const response = await this.getProjectPostsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Paged list of projects
    */
    async getProjectsRaw(requestParameters: GetProjectsRequest): Promise<runtime.ApiResponse<ProjectPageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.query !== undefined) {
              queryParameters['query'] = requestParameters.query;
          }

          if (requestParameters.categories) {
            queryParameters['categories'] = requestParameters.categories;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/projects`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPageResponseFromJSON(jsonValue));
      }

      /**
        * Paged list of projects
      */
      async getProjects(requestParameters: GetProjectsRequest): Promise<ProjectPageResponse> {
        const response = await this.getProjectsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Update the project associated with the given projectId
    */
    async updateProjectRaw(requestParameters: UpdateProjectRequest): Promise<runtime.ApiResponse<ProjectResponse>> {
          if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
          throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling updateProject.');
          }

          if (requestParameters.projectRequest === null || requestParameters.projectRequest === undefined) {
          throw new runtime.RequiredError('projectRequest','Required parameter requestParameters.projectRequest was null or undefined when calling updateProject.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
              body: ProjectRequestToJSON(requestParameters.projectRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
      }

      /**
        * Update the project associated with the given projectId
      */
      async updateProject(requestParameters: UpdateProjectRequest): Promise<ProjectResponse> {
        const response = await this.updateProjectRaw(requestParameters);
        return await response.value();
      }

    }
